export default __webpack_public_path__ + "static/media/MDV_C__0004_Layer-2.e34bb630.png";